import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateSendDownloadLinksForm = document.createElement('template');

templateSendDownloadLinksForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container' id='loading-element'>
      <gz-progress-spinner spinnerwidth='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>

      <div class='form-wrapper'>

        <gz-title fontSize='${FontSizes.PARAGRAPH_11}' fontWeight='${FontWeights.SEMIBOLD}' id='add-email-subtitle' class='form-subtitle-download-links'>
        </gz-title>

        <div class='form-section'>
          <gz-form-field id='email-address-form-field'>
              <gz-chips-generator-input gz-form-input inputWidth='480'></gz-chips-generator-input>
              <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <gz-title fontSize='${FontSizes.PARAGRAPH_11}' fontWeight='${FontWeights.SEMIBOLD}' id='installation-links-subtitle' class='form-subtitle-download-links'>
        </gz-title>

        <div class='form-section'>
          <gz-form-field id='ring-selector-formfield' class="hidden">
              <gz-input gz-form-input id='ring-selector-input' class='hidden'></gz-input>
              <gz-single-select id="ring-selector-dropdown"></gz-single-select>
          </gz-form-field>
        </div>

        <div class='form-section'>
          <!-- windows os -->
          <gz-form-field id='windows-downloader-form-field'>
            <gz-copy-to-clipboard id='gz-copy-to-clipboard-windows-link'>
              <gz-input gz-form-input id='windows-downloader-link' class='hidden'></gz-input>
              <gz-link id='windows-downloader-link-display' type='underline' color='primary' class='gz-link-config'>
              </gz-link>
            </gz-copy-to-clipboard>
          </gz-form-field>

          <!-- linux os -->
          <gz-form-field id='linux-installer-form-field'>
            <gz-copy-to-clipboard id='gz-copy-to-clipboard-linux-link'>
              <gz-input gz-form-input id='linux-installer-link' class='hidden'></gz-input>
              <gz-link id='linux-installer-link-display' type='underline' color='primary' class='gz-link-config'>
              </gz-link>
            </gz-copy-to-clipboard>
          </gz-form-field>

          <!-- mac os -->
          <gz-form-field id='macos-downloader-form-field'>
            <gz-copy-to-clipboard id='gz-copy-to-clipboard-macos-link'>
              <gz-input gz-form-input id='macos-downloader-link' class='hidden'></gz-input>
              <gz-link id='macos-downloader-link-display' type='underline' color='primary' class='gz-link-config'>
              </gz-link>
            </gz-copy-to-clipboard>
          </gz-form-field>
        </div>

        <p class='form-subtitle-info' id='form-packages-info'></p>
      </div>

      <div class='bottom-buttons'>
        <gz-button data-confirm='true' id='send-emails-button' disabled>
        </gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' data-cancel='true' id='cancel-button'>
        </gz-button>
      </div>

    </div>
  </div>
`;
